import dayjs from 'dayjs';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../utils/formatDate';
import { getTimeDifference } from '../../utils/getTimeDifference';
import { InputTable } from '../../assets/styles/InputTable';
import GetFetchStatus from '../../hooks/GetFetchStatus';
import IssueGuide from '../IssueGuide';
import SkeletonTable from '../SkeletonTable';
import { IUser, userState } from '../../atoms';

// 출입 장비  연결 정보
export const EquipInfo = ({ name }: { name: string }) => {
  const { t } = useTranslation();
  const userInfo = useRecoilValue<IUser>(userState);
  const { hCd, sCd } = userInfo;
  const now = dayjs();
  const currentTime = now.format('YYYY-MM-DD HH:mm:ss');
  const { data, isLoading, isError, refetch } = GetFetchStatus({ path: '/setting/faceSet', enabledKey: !!hCd && !!sCd && sCd !== '00000' });

  const onClickRefresh = () => {
    refetch();
  };

  const statusRender = (time: string) => {
    const currentStatusIdx: 0 | 1 | 2 = getTimeDifference(currentTime, time); // 0: 15분 이내[ON], 1: 30분 이내[WAIT], 2: 30분 초과[OFF]

    switch (currentStatusIdx) {
      case 0:
        return <span className='greenLight'>ON</span>;
      case 1:
        return <span className='orangeLight'>WAIT</span>;
      default:
        return <span className='redLight'>OFF</span>;
    }
  };

  const loading = !data || isLoading;
  if (isError) return <IssueGuide />;
  return (
    <div className='equipInfo'>
      <div className='widget-header'>
        <div className='widget-title flex-between'>
          <span>
            {t(name)}
            <span className='badge'>{data?.faceSet.length ?? 0}</span>
          </span>
          <div className='refresh-btn' onClick={onClickRefresh} role='presentation'>
            <span className='material-symbols-rounded'>refresh</span>
          </div>
        </div>
      </div>
      {loading ? (
        <div style={{ width: '100%', height: '100%' }}>
          <SkeletonTable />
        </div>
      ) : (
        <div className='widget-body table'>
          <InputTable>
            <div className='thead'>
              <div className='tr'>
                <div className='trCol2p5 flex-center tableStickyNo content-overflow padding-left text_tertiary'>{t('출입 장비명')}</div>
                <div className='trCol10 flex-center text_tertiary'>{t('최종 연결')}</div>
                <div className='trCol4 flex-center padding-right text_tertiary'>{t('상태')}</div>
              </div>
            </div>
            <div className='table'>
              <div className='tbody'>
                {data.faceSet?.length > 0 ? (
                  data.faceSet.map((el: any, i: number) => (
                    <div className='tr' key={`equipInfo_${i}`}>
                      <div className='trCol2p5 flex-basic tableStickyNo content-overflow padding-left text_primary'>{el.fName}</div>
                      <div className='trCol10 flex-end shrink0 text_disabled'>
                        <span className=''>{formatDate(el.fLastdate)}</span>
                      </div>
                      <div className='trCol4 flex-center shrink0 padding-right'>{statusRender(el.fLastdate)}</div>
                    </div>
                  ))
                ) : (
                  <div className='noData'>No data.</div>
                )}
              </div>
            </div>
            {/* <tfoot>
              <div className='tr'>
                <div className='trCol2p5 flex-basic tableStickyNo content-overflow padding-left'>
                  {t('합계')}
                  <span className='subNumber'>{tableState.length}</span>
                </div>
              </div>
            </tfoot> */}
          </InputTable>
        </div>
      )}
    </div>
  );
};
